<template>
  <div class="active_table" ref="content">
    <div class="table">
      <h1>应急响应流程图</h1>
      <br>
      <img src="/contingency/xiangyingliucheng.png" alt="应急响应流程图">
    </div>
  </div>
</template>
  
<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
  padding-top: 2em;
  text-align: center;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    height: 100%;
  }
}
</style>

<script>
export default {
  data() {
    return {
    };
  },
  components: {
  },
  created: function () {
  },
  methods: {
  },
};
</script>